import { WebIO } from '@gltf-transform/core';
import { ALL_EXTENSIONS } from '@gltf-transform/extensions';
import { metalRough } from '@gltf-transform/functions';

const SPEC_GLOSS_EXT = 'KHR_materials_pbrSpecularGlossiness';

/** True if a GLB/GLTF ArrayBuffer declares the archived specular-glossiness extension. */
export function bufferUsesSpecularGlossiness(buffer: ArrayBuffer): boolean {
  try {
    const bytes = new Uint8Array(buffer);
    const magic = String.fromCharCode(bytes[0], bytes[1], bytes[2], bytes[3]);
    if (magic === 'glTF') {
      // GLB: JSON chunk starts after 12-byte header + 8-byte chunk header.
      const jsonLength = bytes[12] | (bytes[13] << 8) | (bytes[14] << 16) | (bytes[15] << 24);
      const jsonStart = 20;
      const json = new TextDecoder().decode(bytes.subarray(jsonStart, jsonStart + jsonLength));
      return json.includes(SPEC_GLOSS_EXT);
    }
    const text = new TextDecoder().decode(bytes.subarray(0, Math.min(bytes.byteLength, 256_000)));
    return text.includes(SPEC_GLOSS_EXT);
  } catch {
    return false;
  }
}

/**
 * Losslessly convert archived KHR_materials_pbrSpecularGlossiness → metallic-roughness
 * so modern THREE.GLTFLoader can load materials/textures.
 */
export async function convertSpecularGlossinessToMetalRough(
  buffer: ArrayBuffer,
): Promise<ArrayBuffer> {
  const io = new WebIO().registerExtensions(ALL_EXTENSIONS);
  const document = await io.readBinary(new Uint8Array(buffer));
  await document.transform(metalRough());
  const out = await io.writeBinary(document);
  return out.buffer.slice(out.byteOffset, out.byteOffset + out.byteLength);
}
